import openSocket from "socket.io-client";

import api from "./api";

// Connect to the same origin; the proxy forwards /socket.io to the backend.
export function connectToSocket() {
  // O handshake é AUTENTICADO: o servidor recusa conexão sem token e deriva as
  // salas do dono a partir dele (ver backend libs/socket.ts). O token vem do
  // header que o useAuth mantém — assim nenhum chamador precisa passá-lo, e uma
  // sessão de visualização (backoffice) já conecta como o cliente observado.
  // `auth` é uma função: a cada reconexão o token corrente é lido de novo, em
  // vez de congelar o que valia quando o socket foi criado.
  return openSocket(window.location.origin, {
    transports: ["polling", "websocket"],
    withCredentials: true,
    auth: cb => cb({ token: api.defaults.headers.Authorization || "" }),
  });
}
